import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';
import Slider from 'react-slick';
import NextArrow from '../../Layouts/ProductDetailsV2/_common/nextArrow';
import PrevArrow from '../../Layouts/ProductDetailsV2/_common/prevArrow';
/* Components */
import CartDeleteMutation from '../../../mutationsModern/Cart/CartV2DeleteMutation';

import ProductListItem from '../Product/ProductListItem/ProductListItem';
/* Styles */
import './imageGallery.scss';
import '../../Layouts/ProductDetailsV2/_common/Slider.scss';
import '../../Layouts/ProductDetailsV2/_common/SlickSlider.scss';
import CartAddMutation from '../../../mutationsModern/Cart/CartV2AddMutation';
import { urlProductCatalogPage } from '../../../../server/utils/routeConstants';

class ImageGallery extends React.PureComponent {
  static propTypes = {
    galleryTitle: PropTypes.string,
    gallerySummary: PropTypes.node,
    isVerticallyCentered: PropTypes.bool,
    user: PropTypes.object.isRequired,
    galleryImages: PropTypes.object,
    category: PropTypes.string.isRequired,
    shopNavOpen: PropTypes.bool.isRequired,
    headerUrl: PropTypes.string,
    newCategory: PropTypes.string,
    handleRouteChange: PropTypes.func.isRequired,
    handleCartAddClick: PropTypes.func,
    handleAuthentication: PropTypes.func,
    removeFromCart: PropTypes.func,
    showSlider: PropTypes.bool,
    slidesToScroll: PropTypes.number,
    slidesToShow: PropTypes.number,
    showDots: PropTypes.bool,
    accountId: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      cartMutationLoading: false,
    };
  }

  handleRouteChange = e => {
    e.preventDefault();
    const { headerUrl } = this.props;
    if (!headerUrl) return;
    window.location.href = `${urlProductCatalogPage}${headerUrl}`;
  };

  onCartAddCompletion = () => {
    this.setState({ cartMutationLoading: false });
  };

  getCartItem = ({ user, product }) => {
    return user.cart.entries.edges.find(
      ({ node: cartEntry }) =>
        cartEntry.product.productId === product.productId,
    );
  };

  onCartAddMutationError = () => {
    this.setState({ cartMutationLoading: false });
  };

  onCartDeleteMutationComplete = () => {
    this.setState({ cartMutationLoading: false });
  };

  handleCartDelete = (user, product) => {
    const { environment } = this.props.relay;
    const { accountId } = this.props;
    this.setState({ cartMutationLoading: true });
    const { id, productId } = product;
    CartDeleteMutation.commit({
      environment,
      id,
      productId,
      conciergeCustomerAccountId: accountId,
      onCompleted: this.onCartDeleteMutationComplete,
      onError: this.onCartAddMutationError,
    });
  };

  handleCartAdd = ({ product, qty, qtyChange }) => {
    if (!this.props.user) return;
    const { accountId } = this.props;
    const { cartMutationLoading } = this.state;
    if (!cartMutationLoading) {
      this.setState({ cartMutationLoading: true });
      const quantity = qtyChange + qty;
      const { user, relay: { environment } } = this.props;
      const { id, productId } = product;
      if (quantity === 0) {
        this.handleCartDelete(user, product);
      } else {
        CartAddMutation.commit({
          environment,
          id,
          productId,
          quantity,
          conciergeCustomerAccountId: accountId,
          onCompleted: this.onCartAddCompletion,
          onError: this.onCartAddMutationError,
        });
      }
    }
  };

  render() {
    const {
      galleryTitle,
      gallerySummary,
      shopNavOpen,
      containerWidth,
      isVerticallyCentered,
      user,
      handleRouteChange,
      category,
      handleAuthentication,
      galleryImages,
      showSlider,
      slidesToScroll,
      slidesToShow,
      showDots,
    } = this.props;
    const isMobile = containerWidth <= 640;
    if (!galleryImages) return null;
    const settings = {
      dots: showDots,
      infinite: true,
      speed: 300,
      accessibility: true,
      arrows: true,
      draggable: false,
      lazyLoad: false,
      imageContainerWidth: 0,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      slidesToScroll: slidesToScroll || 1,
      slidesToShow: slidesToShow || 1,
    };
    return (
      <div className="imageGallery">
        <Flex wrap justify="center">
          <Box onClick={this.handleRouteChange}>
            <h1 style={{ marginBottom: '24px', padding: '10px 0' }}>
              <span className="galleryTitle">
                {galleryTitle}
              </span>
            </h1>
          </Box>
          {gallerySummary &&
            <Box w={[1]} className="gallerySummary">
              {gallerySummary}
            </Box>}
        </Flex>
        {isMobile || showSlider
          ? <Flex column style={{ margin: '0px 16px' }}>
              <Slider {...settings}>
                {galleryImages.edges.map(({ node: product }) =>
                  <Box
                    style={{ padding: '0' }}
                    key={`image${product.id}`}
                    w={[1, 1, 1, 1 / 3]}>
                    <ProductListItem
                      imageGallery
                      {...{
                        user,
                        product,
                        category,
                        shopNavOpen,
                        containerWidth,
                        isVerticallyCentered,
                        handleRouteChange,
                        handleCartAddClick: this.handleCartAdd,
                        handleAuthentication,
                      }}
                    />
                  </Box>,
                )}
              </Slider>
            </Flex>
          : <Flex wrap>
              {galleryImages.edges.map(({ node: product }) =>
                <Box key={`image${product.id}`} w={[1, 1, 1, 1 / 3]}>
                  <ProductListItem
                    imageGallery
                    {...{
                      user,
                      product,
                      category,
                      shopNavOpen,
                      containerWidth,
                      isVerticallyCentered,
                      handleRouteChange,
                      handleCartAddClick: this.handleCartAdd,
                      handleAuthentication,
                    }}
                  />
                </Box>,
              )}
            </Flex>}
      </div>
    );
  }
}

export default createFragmentContainer(ImageGallery, {
  user: graphql`
    fragment ImageGallery_user on User {
      ...ProductListItem_user
      role
      conciergeCustomerAccountId
      conciergeUser {
        userId
        permissions {
          id
          oneCommerce {
            id
            preferredCustomer {
              access
            }
          }
        }
      }
      permissions {
        id
        oneCommerce {
          id
          ceo {
            access
          }
          preferredCustomer {
            access
          }
        }
      }
      cartV2 {
        id
        cartId
        autoShipEnabled
        autoShipIntervalUnit
        autoShipIntervalCount
        promoCodeSavings
        saleSavings
        canSubscribeForAutoShip
        discountQualifiedCartTotal
        subTotalPriceOfItems
        subTotalPriceOfItemsWithDiscount
        total
        totalSavings
        totalNumberOfItems
        subTotalPriceOfItems
        eventId
        eventHostFirstName
        event {
          id
          eventId
          trinityPartyType
        }
        promoCodes {
          id
          code
          promoDescription
          thresholds {
            discountAmount
            discountAmountEach
          }
        }
        wordPressCoupons {
          code
          couponDescription
          storeBalance
          yotpoCouponCode
        }
        wordPressCouponSavings
        entries(first: 1000) {
          edges {
            node {
              id
              sku
              productId
              quantity
              productName
              productURLslug
              productImageUrl
              wineBottleQuantity
              isWinePack
              priceOriginal
              priceSale
              priceDiscount
              discountEligible
              priceDiscountPercent
              hasQualifyingDiscount
            }
          }
        }
      }
    }
  `,
});
